import { makeStyles } from '@material-ui/core/styles';

export const useProductDescriptionStyles = makeStyles((theme) => ({
  title: {
    fontSize: 16,
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  subtypo: {
    fontSize: 16,
  },
  textContainer: {
    '& :not(:last-child)': {
      marginBottom: 12,
    },
  },
  container: {
    border: '1px solid #BCBCBC',
    borderRadius: 10,
  },
  divider: {
    width: 10,
    height: 120,
    backgroundColor: '#666666',
    borderRadius: '10px 0px 0px 10px',
    marginRight: 15,
  },
}));

export const useIssuesDesktopStyles = makeStyles(() => ({
  subtitle: {
    fontSize: 16,
    marginTop: 44,
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 26,
  },
  rootBreadcrumb: {
    marginTop: -6,
    marginBottom: 30,
  },
  firstBreadcrumb: {
    cursor: 'pointer',
    color: '#464646',
  },
  secondBreadcrumb: {
    color: '#6A148E',
  },
  loader: {
    width: 80,
    height: 80,
    margin: '40px auto',
    display: 'block',
  },
}));

export const useMotiveDesktopStyles = makeStyles(() => ({
  accordion: {
    '&.MuiAccordion-root.Mui-disabled': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
  },
}));
